import * as Types from '../../../../baseType';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebNovelChapterDtoFragment = { __typename?: 'Chapter', storyId: number, chapterId: number, chapterIndex: number, name: string, adsOn: boolean, freedAt?: any | null, price: number, currentPlayingStatus: Types.Chapter_Current_Playing_Status, isAdult: boolean, userPurchasedChapter?: { __typename?: 'UserPurchasedChapter', usedAmount: number } | null };

export type ListChapterByClientQueryVariables = Types.Exact<{
  storyId: Types.Scalars['Int'];
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ListChapterByClientQuery = { __typename?: 'Query', listChapterByClient: { __typename?: 'ListableChapter', totalCount: number, page: number, pageSize: number, list: Array<{ __typename?: 'Chapter', storyId: number, chapterId: number, chapterIndex: number, name: string, adsOn: boolean, freedAt?: any | null, price: number, currentPlayingStatus: Types.Chapter_Current_Playing_Status, isAdult: boolean, userPurchasedChapter?: { __typename?: 'UserPurchasedChapter', usedAmount: number } | null }> } };

export const WebNovelChapterDtoFragmentDoc = gql`
    fragment WebNovelChapterDto on Chapter {
  storyId
  chapterId
  chapterIndex
  name
  adsOn
  freedAt
  price
  currentPlayingStatus
  isAdult
  userPurchasedChapter {
    usedAmount
  }
}
    `;
export const ListChapterByClientDocument = gql`
    query ListChapterByClient($storyId: Int!, $page: Int, $pageSize: Int) {
  listChapterByClient(data: {storyId: $storyId, page: $page, pageSize: $pageSize}) {
    list {
      ...WebNovelChapterDto
    }
    totalCount
    page
    pageSize
  }
}
    ${WebNovelChapterDtoFragmentDoc}`;

/**
 * __useListChapterByClientQuery__
 *
 * To run a query within a React component, call `useListChapterByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChapterByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChapterByClientQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useListChapterByClientQuery(baseOptions: Apollo.QueryHookOptions<ListChapterByClientQuery, ListChapterByClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListChapterByClientQuery, ListChapterByClientQueryVariables>(ListChapterByClientDocument, options);
      }
export function useListChapterByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListChapterByClientQuery, ListChapterByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListChapterByClientQuery, ListChapterByClientQueryVariables>(ListChapterByClientDocument, options);
        }
export type ListChapterByClientQueryHookResult = ReturnType<typeof useListChapterByClientQuery>;
export type ListChapterByClientLazyQueryHookResult = ReturnType<typeof useListChapterByClientLazyQuery>;
export type ListChapterByClientQueryResult = Apollo.QueryResult<ListChapterByClientQuery, ListChapterByClientQueryVariables>;